<section #monitorWindow class="monitor-window" [class.monitor-expanded]="isExpanded">
    <header class="monitor-titlebar">
        <div class="product-identity">
            <span class="connection-icon" [class.connected]="isConnected()" [attr.title]="isConnected() ? 'Connect' : 'Disconnect'">
                <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <ng-container *ngIf="isConnected(); else disconnectedIcon">
                        <path d="M10 13a5 5 0 0 0 7 .1l3-3a5 5 0 0 0-7-7l-1.7 1.7"></path>
                        <path d="M14 11a5 5 0 0 0-7-.1l-3 3a5 5 0 0 0 7 7l1.7-1.7"></path>
                    </ng-container>
                    <ng-template #disconnectedIcon>
                        <path d="M16 3a5 5 0 0 1 4 7l-2 2M8 21a5 5 0 0 1-4-7l2-2M8 8l8 8M3 3l18 18"></path>
                    </ng-template>
                </svg>
            </span>

            <div class="product-information">
                <span class="connection-label" [class.connected]="isConnected()" role="status">
                    {{ isConnected() ? 'BAĞLI UYGULAMA' : 'BAĞLANTI YOK' }}
                </span>

                <div class="product-title-row">
                    <div class="title-marquee" [attr.title]="applicationTitle" [attr.aria-label]="applicationTitle">
                        <span class="scrolling-title" aria-hidden="true">{{ applicationTitle +' '+ applicationVersion }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="window-controls">
            <button type="button" class="window-button maximize-button" [disabled]="isClosed"
                (click)="toggleFullscreen()" [attr.aria-label]="isExpanded ? 'Önceki boyuta dön' : 'Ekranı büyüt'"
                [attr.title]="isExpanded ? 'Önceki boyuta dön' : 'Ekranı büyüt'" [attr.aria-pressed]="isExpanded">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true">
                    <rect *ngIf="!isExpanded" x="5" y="5" width="14" height="14" rx="1.5"></rect>
                    <ng-container *ngIf="isExpanded"><path d="M8 8V4h12v12h-4"></path><rect x="4" y="8" width="12" height="12" rx="1"></rect></ng-container>
                </svg>
            </button>

            <button type="button" class="window-button close-button" [disabled]="isClosed"
                (click)="closeApplication()" aria-label="Uygulamayı kapat" title="Uygulamayı kapat">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true">
                    <path d="M6 6l12 12M18 6L6 18"></path>
                </svg>
            </button>
        </div>
    </header>

    <div class="monitor-content" [attr.aria-busy]="isLoading">
        <div *ngIf="isLoading" class="monitor-placeholder" role="status">Uygulama yükleniyor…</div>

        <iframe *ngIf="safeApplicationUrl" #applicationFrame [src]="safeApplicationUrl" [title]="applicationTitle"
            sandbox="allow-scripts allow-same-origin allow-forms" referrerpolicy="no-referrer" (load)="onFrameLoad()"></iframe>

        <p *ngIf="errorMessage" class="monitor-error" role="alert">{{ errorMessage }}</p>
        <div *ngIf="isClosed" class="monitor-placeholder">Uygulama kapatıldı.</div>
    </div>
</section>
